import React from 'react';
import Helmet from 'react-helmet';
import slugify from 'slugify';

import Hero from '../components/hero';
import PostFooter from '../components/post-footer';

require('prismjs/themes/prism-okaidia.css');

import '../assets/styles/components/figure.scss';
import '../assets/styles/components/logo.scss';
import '../assets/styles/components/title-text-effect.scss';
import '../assets/styles/components/post-footer.scss';
import './blog-post.scss';
import '../assets/styles/components/aside.scss';



const SITE_NAME = 'Alma Developers';


export default function Template({
  data // this prop will be injected by the GraphQL query we'll write in a bit
}) {
  const { markdownRemark: post } = data; // data.markdownRemark holds our post data

  const headerImageSrc = `https://developers.almamedia.fi${post.frontmatter.image.childImageSharp.resize.src}`;
  const articleAbsoluteUrl = `https://developers.almamedia.fi${post.slug}`;

  return (
    <article className="blog-post-container" itemscope itemtype="http://schema.org/BlogPosting">
      <Helmet>

        {/* Basic site metadata */}
        <title>Alma Developers | {post.frontmatter.title}</title>
        <meta name="description" content={post.frontmatter.excerpt} />

        <meta itemprop="datePublished" content={post.frontmatter.date} />
        <meta itemprop="author" content={post.frontmatter.author.id} />

        {/* Facebook metadata */}
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:title" content={post.frontmatter.title} />
        <meta property="og:url" content={articleAbsoluteUrl} />
        <meta property="og:description" content={post.frontmatter.excerpt} />
        <meta property="og:og:type" content="article" />
        <meta property="og:image" content={headerImageSrc} />
        <meta property="og:see_also" content="http://www.almamedia.fi/en" />
        <meta property="fb:profile_id" content="almamedia" />

        {/* Google metadata */}
        <link rel="publisher" href="https://plus.google.com/113775613134836602703" />
        {post.frontmatter.author.gplus &&
          <link rel="author" href={`https://plus.google.com/${post.frontmatter.author.gplus}`} />
        }

        {/* Twitter metadata */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@almadevelopers" />
        <meta name="twitter:title" content={post.frontmatter.title} />
        <meta name="twitter:description" content={post.frontmatter.excerpt} />
        <meta name="twitter:image" content={headerImageSrc} />
        <meta name="twitter:url" content={articleAbsoluteUrl} />

        {/* Schema.org microdata (Hakukoneet & Google+) */}
        <meta itemprop="name" content={SITE_NAME} />
        <meta itemprop="title" content={post.frontmatter.title} />
        <meta itemprop="description" content={post.frontmatter.excerpt} />
        <meta itemprop="image" content={headerImageSrc} />

      </Helmet>
      <div className="blog-post">
        <Hero title={post.frontmatter.title} byline={`Published ${post.frontmatter.date}`} backgroundImage={post.frontmatter.image.childImageSharp.resize.src} />
        <section className="blog-post-content post-content container" dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
      <PostFooter author={post.frontmatter.author} />
    </article>
  );
}

export const pageQuery = graphql`
  query TemplateBlogPost($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      fields {
        slug
      }
      frontmatter {
        title
        excerpt
        date(formatString: "MMMM Do YYYY")
        rawDate: date
        image {
          childImageSharp {
            resize(width: 1920, quality: 75) {
              src
            }
            responsiveSizes(maxWidth: 786) {
              src
              srcSet
              aspectRatio
              base64
              sizes
            }
          }
        }
        author {
          id
          bio
          website
          twitter
          linkedin
          gplus
          avatar {
            childImageSharp {
              responsiveResolution(width: 160, height: 160, quality: 75) {
                src
                srcSet
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.jsx